
<div>
  <alert-banner v-if="bannerType" :status="HelperStatus.Warn">{{ bannerMessage }}</alert-banner>
</div>
